// src/utils/travelCalculations.js
// Helper centralizado para calculos de tempo de viagem

/**
 * Arredonda minutos de viagem (ignora < 5min, arredonda para multiplos de 5)
 * @param {number} minutes - Minutos de viagem
 * @returns {number} Minutos arredondados
 */
export const roundTravelMinute = (minutes) => {
  if (!minutes || minutes <= 4) return 0;
  return Math.floor(minutes / 5) * 5;
};

/**
 * Arredonda para baixo em multiplos de 5
 * @param {number} x - Valor a arredondar
 * @returns {number} Valor arredondado
 */
export const floorTo5 = (x) => {
  if (!x || x < 0) return 0;
  return Math.floor(x / 5) * 5;
};

/**
 * Arredonda para cima em multiplos de 5
 * @param {number} x - Valor a arredondar
 * @returns {number} Valor arredondado
 */
export const ceilTo5 = (x) => {
  if (!x || x < 0) return 0;
  return Math.ceil(x / 5) * 5;
};

/**
 * Calcula tempo total de viagem entre locais
 * @param {Array} travelSegments - Array de segmentos de viagem
 * @returns {number} Tempo total em minutos (arredondado)
 */
export const calculateTotalTravel = (travelSegments) => {
  if (!travelSegments || travelSegments.length === 0) return 0;

  const total = travelSegments.reduce((sum, seg) => {
    return sum + roundTravelMinute(seg.durationMinutes || seg.duration || 0);
  }, 0);

  // Se soma total < 5min mas tem segmentos, retorna pelo menos 5
  if (total === 0 && travelSegments.length > 0) {
    const rawTotal = travelSegments.reduce((sum, seg) =>
      sum + (seg.durationMinutes || seg.duration || 0), 0);
    if (rawTotal > 0) return 5;
  }

  return total;
};

/**
 * Calcula distancia total de viagem
 * @param {Array} travelSegments - Array de segmentos de viagem
 * @returns {number} Distancia total em metros
 */
export const calculateTotalDistance = (travelSegments) => {
  if (!travelSegments || travelSegments.length === 0) return 0;

  return travelSegments.reduce((sum, seg) => {
    return sum + (seg.distanceMeters || seg.distance || 0);
  }, 0);
};

/**
 * Formata tempo de viagem para exibicao
 * @param {number} minutes - Minutos de viagem
 * @returns {string} Tempo formatado
 */
export const formatTravelTime = (minutes) => {
  if (!minutes || minutes <= 0) return '0 min';

  if (minutes < 60) {
    return `${Math.round(minutes)} min`;
  }

  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);

  if (mins === 0) {
    return `${hours}h`;
  }

  return `${hours}h ${mins}min`;
};

/**
 * Calcula tempo de trabalho total (servico + viagem)
 * @param {number} serviceMinutes - Minutos de servico
 * @param {number} travelMinutes - Minutos de viagem
 * @returns {number} Total em minutos
 */
export const calculateTotalWorkTime = (serviceMinutes, travelMinutes) => {
  return (serviceMinutes || 0) + (travelMinutes || 0);
};
